var _defs, _rect, _text, _line, _line2, _line3, _line4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _g, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg5PeakHour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 680 240",
    xmlns: "http://www.w3.org/2000/svg",
    width: 680,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n    @keyframes ph-grow{from{height:0;y:160}to{}}\n    @keyframes peak-pulse{0%,100%{filter:url(#ph-glow);opacity:.9}50%{filter:url(#ph-glow2);opacity:1}}\n    @keyframes scan{0%{x:55}100%{x:635}}\n    @keyframes pointer-bounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-4px)}}\n    .phb1{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) .1s both}\n    .phb2{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) .2s both}\n    .phb3{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) .3s both}\n    .phb4{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) .4s both}\n    .phb5{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) .5s both}\n    .phb6{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) .6s both}\n    .phb7{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) .7s both}\n    .phb8{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) .8s both}\n    .phb9{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) .9s both}\n    .phb10{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) 1s both}\n    .phb11{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) 1.1s both}\n    .phb12{animation:ph-grow .5s cubic-bezier(.4,0,.2,1) 1.2s both}\n    .peak-bar{animation:peak-pulse 1.5s ease-in-out infinite 1.4s both}\n    .ptr{animation:pointer-bounce 1.2s ease-in-out infinite 1.8s}\n  "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#060912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#060f1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph-bar",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f3460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e40af"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ph-peak",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0ea5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#38bdf8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ph-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ph-glow2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 240,
    fill: "url(#ph-bg)",
    rx: 20
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 28,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    letterSpacing: 2
  }, "PEAK USAGE HOUR DETECTION \u2014 LAST 30 DAYS")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 160,
    x2: 635,
    y2: 160,
    stroke: "#1e293b",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 120,
    x2: 635,
    y2: 120,
    stroke: "#0f1e35",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 80,
    x2: 635,
    y2: 80,
    stroke: "#0f1e35",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 50,
    x2: 635,
    y2: 50,
    stroke: "#0f1e35",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "phb1",
    x: 60,
    y: 150,
    width: 36,
    height: 10,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "phb2",
    x: 107,
    y: 148,
    width: 36,
    height: 12,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "phb3",
    x: 154,
    y: 140,
    width: 36,
    height: 20,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "phb4",
    x: 201,
    y: 130,
    width: 36,
    height: 30,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "phb5",
    x: 248,
    y: 120,
    width: 36,
    height: 40,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "phb6",
    x: 295,
    y: 130,
    width: 36,
    height: 30,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "phb7",
    x: 342,
    y: 140,
    width: 36,
    height: 20,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "phb8 peak-bar",
    x: 389,
    y: 60,
    width: 36,
    height: 100,
    rx: 3,
    fill: "url(#ph-peak)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "phb9",
    x: 436,
    y: 100,
    width: 36,
    height: 60,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "phb10",
    x: 483,
    y: 120,
    width: 36,
    height: 40,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "phb11",
    x: 530,
    y: 140,
    width: 36,
    height: 20,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.6
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "phb12",
    x: 577,
    y: 148,
    width: 36,
    height: 12,
    rx: 3,
    fill: "url(#ph-bar)",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ptr"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 407,
    y1: 55,
    x2: 407,
    y2: 40,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 22,
    width: 82,
    height: 20,
    rx: 6,
    fill: "#0c2a3a",
    stroke: "#38bdf8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 407,
    y: 36,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    fontWeight: 700
  }, "PEAK \u2014 9 PM"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "9am")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "11am")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "1pm")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 219,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "3pm")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 266,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "5pm")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 313,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "6pm")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "7pm")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 407,
    y: 176,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    fontWeight: 700
  }, "9pm \u2605")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 454,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "10pm")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 501,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "11pm")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "12am")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 176,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "1am")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 210,
    textAnchor: "middle",
    fill: "#1e293b",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Send notifications at peak hour for maximum engagement")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg5PeakHour);
export default __webpack_public_path__ + "static/media/svg5-peak-hour.55662d93d0c833618d4f5483a4106e03.svg";
export { ForwardRef as ReactComponent };